// AI Generated Component
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { AccessibilityFastTrackRepoService } from '@client/app/services/api/accessibility/accessibility-fast-track-repo/accessibility-fast-track-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { AccessibilityFastTrackService } from '@client/app/modules/accessibility/dialogs/fast-track/service/fast-track.service';
import { AccessibilityAutofixService } from '@client/app/modules/page-fix/services/accessibility-auto-fix/accessibility-auto-fix.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { PageAccessibilityRepoService } from '@client/app/services/api/page-accessibility/page-accessibility-repo.service';
import { ExtensionService } from '@client/app/modules/extension/services/extension.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { AccessibilityService } from '@client/app/services/entities/accessibility/accessibility.service';
import { FastTrackService } from '@client/app/modules/fast-track/services/fast-track/fasttrack.service';
import { FastTrackDialogsPagesComponent } from '@client/app/modules/accessibility/dialogs/fast-track-pages/fast-track-pages.component';
import {
    ExtensionGuideDialogComponent,
} from '@client/app/modules/extension/components/extension-guide-dialog/extension-guide-dialog.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'accessibility-fast-track',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header [icon]="['ACCESSIBILITY', 'FASTTRACK'] | monIcons"
                         [header]="'Accessibility Fast Track' | translate"
                         [subHeader]="'With Fast Track you can fix, review and ignore HTML snippets on affected pages all in one go' | translate">
            </page-header>
        </div>

        <div class="mon-dialog-body accessibility-fast-track">
            <div class="row max-height">
                <div class="col-lg-22 pr-lg-0 max-height bg-white border-r border-grey border-size-1 ft-table-container">
                    <div class="row">
                        <div class="offset-34 col-14 pr-0 pr-lg-3">
                            <table-search [minSearchLength]="'3'"
                                          [placeholderTxt]="'Search...' | translate"
                                          [(model)]="search"
                                          (modelChange)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                    <table-container-pager [collection]="snippets"
                                           [page]="page"
                                           [pageSize]="pageSize"
                                           (onPageChange)="onPageChange($event)"
                                           (onPerPageChange)="onPageSizeChange($event)"
                                           [progress]="progress">
                        <fast-track-table [snippets]="snippets"
                                          [activeSnippet]="activeSnippet"
                                          (setActiveSnippet)="setActiveSnippet($event.snippet)">>
                        </fast-track-table>
                    </table-container-pager>
                </div>
                <div class="col-lg-26 pl-lg-0 bg-light-grey max-height">
                    <div class="max-height scroll-y px-3" *ngIf="hasSnippet()">
                        <mon-spinner [loading]="loadingChecks || loadingSnippet">
                            <fast-track-information [affectedPagesCount]="affectedPagesCount"
                                                    [chartData]="chartData"
                                                    [snippet]="activeSnippet">
                            </fast-track-information>
                            <div class="card panel-monsido-card" *ngIf="checks.length > 0">
                                <div class="card-body py-3">
                                    <table class="table table-fixed table-hover remove-table-header-bottom-border checks-table">
                                        <thead>
                                        <tr>
                                            <th class="col-lg-3 col-md-3"><span class="sr-only" translate>Accessibility Icon</span></th>
                                            <th [ngClass]="{'col-lg-26 col-md-21': !showAutofix, 'col-lg-34 col-md-31': showAutofix}" translate>Check</th>
                                            <th class="col-lg-4 col-md-4 text-center"></th>
                                            <th class="col-lg-8 col-md-10 text-center" translate *ngIf="showAutofix">PageCorrect</th>
                                            <th class="col-lg-6 col-md-7 text-center" translate>Action</th>
                                            <th class="col-lg-5 col-md-7 text-right">&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let check of checks" [ngClass]="{'captioned': isClosedCaption(activeSnippet, check) }">
                                            <td class="text-v-middle">
                                                <mon-table-policy-type
                                                    class="inline-block"
                                                    [color]="check.issue_abbr | wcagClass"
                                                    [passed]="false"
                                                    [target]="check.result_type">
                                                </mon-table-policy-type>
                                            </td>
                                            <td class="text-v-middle">
                                                <div [innerHTML]="check.name"></div>
                                                <div>
                                                    <acc-responsibilities [responsibilities]="check.responsibilities" [icon]="true"></acc-responsibilities>
                                                    <acc-guideline-description [check]="check"></acc-guideline-description>
                                                </div>
                                            </td>
                                            <td class="text-v-middle">
                                                <acc-help-center-btn [check]="check"></acc-help-center-btn>
                                            </td>
                                            <td class="text-v-middle text-center" *ngIf="showAutofix">
                                                <page-fix-icon (cb)="updateSnippet(activeSnippet)"
                                                               [type]="check.getPageFixType()"
                                                               [typeId]="check.getPageFixFixableId(activeSnippet.id)"
                                                               [model]="check"
                                                               *ngIf="check.page_fix_fixable">
                                                </page-fix-icon>
                                            </td>
                                            <td class="text-center text-v-center text-v-middle">
                                                <mon-action-menu [monActionMenuItems]="check.dropdown">
                                                    <span translate>Action</span>
                                                </mon-action-menu>
                                            </td>
                                            <td class="text-right">
                                                <pages-button (callback)="openPages(check)"
                                                              [monAriaLabel]="'Show pages with issues' | translate"
                                                              [ngModel]="check.pages_count">
                                                </pages-button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h3 class="pt-10 text-center text-grey font-weight-300"
                                *ngIf="checks.length === 0"
                                translate>
                                There are no more errors for this Snippet
                            </h3>
                        </mon-spinner>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class AccessibilityFastTrackComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    snippets: any[] = [];
    checks: any[] = [];
    activeSnippet: any = null;
    loadingChecks: boolean = false;
    loadingSnippet: boolean = false;
    affectedPagesCount: number = 0;
    chartData: number[] = [0, 1];
    showAutofix: boolean = false;
    allowIgnoreAction: boolean = false;
    extensionInstalled: boolean = false;
    progress: any;

    constructor (
        private accessibilityFastTrackRepo: AccessibilityFastTrackRepoService,
        private monEventService: MonEventService,
        private accessibilityFastTrackService: AccessibilityFastTrackService,
        private accessibilityAutofixService: AccessibilityAutofixService,
        private activeFeatureService: ActiveFeatureService,
        private pageAccessibilityRepoService: PageAccessibilityRepoService,
        private extensionService: ExtensionService,
        private translateService: TranslateService,
        private monModalService: MonModalService,
        private accessibilityService: AccessibilityService,
        private fastTrackService: FastTrackService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        this.accessibilityFastTrackService.clear();
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            status: 'all',
        };

        if (this.search) {
            params.search = this.search;
        }

        this.progress = this.accessibilityFastTrackRepo.getAll(params).then((snippets: any) => {
            if (snippets.length > 0 && !this.hasSnippet()) {
                this.setActiveSnippet(snippets[0]);
            }
            this.snippets = snippets;
        });
    };

    hasSnippet (): boolean {
        return this.activeSnippet != null;
    }

    setActiveSnippet (snippet: any): void {
        this.activeSnippet = snippet;
        this.getChecks();
    }

    openExample (check: any): void {
        const paramsExample: any = {
            page: 1,
            page_size: 1,
            sort_by: 'hits',
            sort_dir: 'desc',
        };

        this.accessibilityFastTrackRepo.getAllPages(this.activeSnippet.id, check.id, paramsExample).then((data: any) => {
            if (!data || data.length === 0) {
                return;
            }
            const page = data[0];
            const errorParams: any = {
                page: 1,
                page_size: 1,
            };
            return this.pageAccessibilityRepoService.getAllCheckErrors(page.id, check.id, errorParams).then((errors: any) => {
                if (!errors || errors.length === 0) {
                    return;
                }
                if (!this.extensionInstalled) {
                    const dialogParams = {
                        body: ExtensionGuideDialogComponent,
                        size: 'sm',
                        classes: 'fade-animation middle center',
                    };
                    this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params: dialogParams });
                    return;
                }
                const deeplinkParams: any = {
                    page: page,
                    type: 'acc',
                    data: { check: check, error: errors[0] },
                    issueId: errors[0].id,
                };
                if (this.extensionService.getDeeplinkMethod() === 'beacon') {
                    this.extensionService.sendDeeplinkMessage('deeplink/openPage', {
                        url: page.url,
                        params: this.extensionService.getExtensionDeeplinkParams(deeplinkParams),
                    });
                } else {
                    window.open(this.extensionService.getExtensionDeepLink(deeplinkParams), '_blank');
                }
            });
        });
    }

    markAsReviewed (check: any, type: string): void {
        const snippet = this.activeSnippet;
        const translation = this.translateService.getString('<strong>[[checkName]]</strong><br><br>Add reason (Optional)', {
            checkName: check.name,
        });

        this.monModalService.prompt(translation, '').then((result: any) => {
            const payload: any = {
                id: check.id,
                comment: result,
                ignored_reviewed: true,
            };
            if (type === 'Ignore') {
                payload.ignored = true;
            }
            this.accessibilityService.fastTrackUpdateCheck(snippet.id, payload, type).then(() => {
                if (this.activeSnippet.id === snippet.id) {
                    this.updateSnippet(this.activeSnippet);
                }
            });
        });
    }

    markCheckAsFixed (check: any): void {
        const domainId = this.sessionService.domain?.id?.toString() || '';
        this.fastTrackService.markCheckAsFixed(domainId, this.activeSnippet.id, check.id).then(() => {
            this.updateSnippet(this.activeSnippet);
        });
    }

    updateSnippet (snippet: any): void {
        this.loadingSnippet = true;
        this.accessibilityFastTrackRepo.get(snippet.id)
            .then((newSnippet: any) => {
                if (this.activeSnippet.id === snippet.id) {
                    this.activeSnippet.caused_issues = this.checks.length;
                    this.activeSnippet.effect_on_compliance = newSnippet.effect_on_compliance;
                    this.getChecks();
                }
            })
            .finally(() => {
                this.loadingSnippet = false;
            });
    }

    openPages (check: any): void {
        const params = {
            body: FastTrackDialogsPagesComponent,
            size: 'lg',
            data: {
                accessibilitySourceCodeId: this.activeSnippet.id,
                check: check,
            },
        };

        const callback = () => {
            this.updateSnippet(this.activeSnippet);
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    isClosedCaption (snippet: any, check: any): boolean {
        return this.accessibilityFastTrackService.isClosedCaption(snippet, check);
    }

    closeCaptionSuccess (): void {
        this.accessibilityFastTrackService.closeCaptionSuccess(this.activeSnippet, null);
    }

    private activate (): void {
        this.monEventService.run('openFasttrack');
        this.search = '';
        this.snippets = [];
        this.checks = [];
        this.activeSnippet = null;
        this.loadingChecks = false;
        this.affectedPagesCount = 0;
        this.chartData = [0, 1];
        this.showAutofix =
            this.activeFeatureService.isFeatureActive('page_fix_accessibility_check') ||
            this.activeFeatureService.isFeatureActive('page_fix_accessibility_source_code');
        this.allowIgnoreAction = !this.sessionService.isDomainGroup();
        this.extensionService.isInstalled().then((res: boolean) => {
            this.extensionInstalled = res;
        });
        this.accessibilityFastTrackService.setupSession();
        this.getPage();
    }

    private getChecks (): void {
        if (this.activeSnippet === null) {
            return;
        }
        const snippet = this.activeSnippet;
        this.loadingChecks = true;
        this.accessibilityFastTrackRepo.getAllChecks(snippet.id)
            .then(
                (checks: any) => {
                    return this.accessibilityAutofixService.parseChecks(checks, snippet).then((parsedChecks: any) => {
                        this.checks = parsedChecks;
                        this.updateDropdowns();
                        snippet.caused_issues = this.checks.length;
                    });
                },
                () => {
                    this.checks = [];
                },
            )
            .finally(() => {
                this.loadingChecks = false;
                this.affectedPagesCount = this.accessibilityFastTrackService.getAffectedPagesCount(this.checks);
                const crawledPages = this.sessionService.domain?.crawled_pages || 0;
                this.chartData = [this.affectedPagesCount, crawledPages - this.affectedPagesCount];
            });
    }

    private updateDropdowns (): void {
        for (const check of this.checks) {
            const dropdown = [
                {
                    label: this.translateService.getString('Review'),
                    leftIcon: 'faEye',
                    action: () => this.markAsReviewed(check, 'Review'),
                    eventParams: { action: 'fasttrack-review' },
                    shouldShow: check.result_type === 'review',
                },
                {
                    label: this.translateService.getString('Ignore'),
                    leftIcon: 'faEyeSlash',
                    action: () => this.markAsReviewed(check, 'Ignore'),
                    eventParams: { action: 'fasttrack-ignore' },
                    shouldShow: this.allowIgnoreAction && (check.result_type === 'error' || check.result_type === 'warning'),
                },
                {
                    label: this.translateService.getString('Mark check as fixed'),
                    leftIcon: 'faCheck',
                    action: () => this.markCheckAsFixed(check),
                    eventParams: { action: 'fasttrack-mark-fixed' },
                    shouldShow: check.result_type === 'error' || check.result_type === 'warning',
                },
                {
                    label: this.translateService.getString('Open example'),
                    leftIcon: 'faSearch',
                    action: () => this.openExample(check),
                },
            ];

            check.dropdown = dropdown.filter((option: any) => option.shouldShow !== false).map((item: any) => {
                return {
                    label: item.label,
                    leftIcon: item.leftIcon,
                    action: () => {
                        if (item.eventParams) {
                            this.monEventService.run('actionTrigger', item.eventParams);
                        }

                        item.action();
                    },
                };
            });
        }
    }
}
